// Three.js CDN version - Shopify compatible
import * as THREE from 'three';
import { GLTFLoader } from 'three/addons/loaders/GLTFLoader.js';

// レンダラー設定
const canvasElement = document.querySelector('#myCanvas');
const renderer = new THREE.WebGLRenderer({
  antialias: true,
  canvas: canvasElement,
  alpha: true,
  powerPreference: "high-performance",
});
renderer.setSize(window.innerWidth, window.innerHeight);
renderer.outputEncoding = THREE.sRGBEncoding;
renderer.toneMapping = THREE.ACESFilmicToneMapping;
renderer.toneMappingExposure = 1.0;
renderer.setPixelRatio(window.devicePixelRatio);

//スマホの場合は
if (window.matchMedia('(max-width: 768px)').matches) {
  renderer.setPixelRatio(Math.min(window.devicePixelRatio, 1.9));
  renderer.antialias = false;
  renderer.shadowMap.enabled = false;
}

// シーンとカメラ
const scene = new THREE.Scene();
const camera = new THREE.PerspectiveCamera(45, window.innerWidth / window.innerHeight, 0.1, 100);
camera.position.set(0, 0.072, 0.5);
camera.rotation.set(0, 0, 0.36);

const pointLight = new THREE.PointLight(0xfff5f5, 0.7);
pointLight.position.set(0, 0.06, 0.38);
scene.add(pointLight);

const pointLight02 = new THREE.PointLight(0xfff3f3, 0.7);
pointLight02.position.set(-0.1, 0.07, 0.33);
scene.add(pointLight02);

const pointLight03 = new THREE.PointLight(0xefcccc, 0.7);
pointLight03.position.set(0.08, 0.06, 0.33);
scene.add(pointLight03);

// モデル読み込み
const loader = new GLTFLoader();
let model;

// Shopify asset URL will be injected via data attribute
const modelUrl = canvasElement.dataset.modelUrl;

loader.load(modelUrl, (gltf) => {
  model = gltf.scene;

  if (window.matchMedia('(max-width: 768px)').matches) {
    // SP
    model.scale.set(2.0, 2.0, 2.0);
  } else {
    // PC
    model.scale.set(2.7, 2.7, 2.7);
  }

  model.position.set(-0.005, 0, 0);
  model.rotation.set(-0.3, -1.6, 0);

  model.traverse((child) => {
    if (child.isMesh) {
      if (child.material.map) {
        // 高品質テクスチャ設定
        const tex = child.material.map;
        tex.generateMipmaps = true;
        tex.minFilter = THREE.LinearMipmapLinearFilter;
        tex.magFilter = THREE.LinearFilter;
        tex.anisotropy = renderer.capabilities.getMaxAnisotropy();
        tex.needsUpdate = true;
      }

      if (child.name === "bottle") {
        child.material.roughness = 1;
        child.material.ior = 1.8;
        child.material.metalness = 0.01;
        child.material.transmission = 1;
      }

      if (child.name === "bottle_logo") {
        child.material.transparent = true;
        child.material.roughness = 0.4;
        child.material.opacity = 0.4;
        child.material.metalness = 0.5;
        child.material.ior = 1;
      }
    }
  });

  scene.add(model);
});

// リサイズ対応
window.addEventListener("resize", () => {
  camera.aspect = window.innerWidth / window.innerHeight;
  camera.updateProjectionMatrix();
  renderer.setSize(window.innerWidth, window.innerHeight);
});

// レンダリングループ
function animate() {
  requestAnimationFrame(animate);
  if (model) {
    model.rotation.y += 0.015;
  }

  renderer.render(scene, camera);
}
animate();
